<div class="login" [ngClass]="getBackgroundImg()">
    <div class="container-fluid" dir="ltr">
        <div class="row">
            <div class="col-lg-4 col-md-7 col-xs-12">
                <div class="login-box" dir="ltr">

                    <div class="col-5 ">
                        <img class="p-1" alt="" src="../../assets/images/bg/logo.jpg"
                            style="width: 268%;height: 284px; border-radius:8%">

                    </div>

                    <!-- popup auth -->
                    <div *ngIf="!authResult" [ngClass]="{'d-none': showMessage}"
                        class="alert alert-danger text-white text-center error-span" style="
                        box-shadow: 2px 8px 14px rgba(255, 0, 0, 0.25);
                        width: max-content;
                        background-color: #dc3545;
                        cursor: pointer;
                        border-color: #dc3545;" (click)="showMessage = true;">
                        <!-- <button class="close" data-close="alert"></button> -->
                        <!-- <span> بيانات غير صحيحه </span> -->
                        <span class="fas fa-exclamation-triangle" style="
                            display: unset;
                            margin: 0;
                            color: #fff;
                            font-family: Font Awesome\ 5 Free !important;
                            font-size: medium;"></span> {{errorMsg}}
                    </div>

                    <!--logo-login-->

                    <h4 class="header">Login Form </h4>
                    <span>Please Enter User Name & Password</span>
                    <!-- <h4 class="header">تسجيل الدخول </h4>
                    <span>من فضلك ادخل البيانات الاساسية</span> -->
                    <div class="row m-0 mb-3">
                        <i class=" col-1 fa fa-user-o" style="left:-15px"></i>
                        <input class=" col-11 login-inputs" id="username" #userName="ngModel" required
                            [(ngModel)]="loginModel.userName" type="text" autocomplete="off" placeholder="User Name"
                            name="username" />
                    </div>
                    <!--row-->
                    <div class="row m-0 mb-3">
                        <i class=" col-1  fa fa-lock" style="left:-15px"></i>
                        <input class="col-11 login-inputs" [(ngModel)]="loginModel.password" id="password"
                            #password="ngModel" required type="password" placeholder="Password" autocomplete="off" />
                    </div>

                    <div class="row m-0 mb-3">
                        <button autofocus (keydown.enter)="login()" (click)="login()">Login</button>

                    </div>
                    <!--row-->


                </div>
            </div>
            <div class="col-md-5"></div>
        </div>
    </div>
    <!--login-box-->

    <!-- <div class="col-12">
        <div class="copyright">All Copyright Reserved To Selat &#169; 2020</div>
    </div> -->
</div>